import common from '../common';

export default class Scene extends P3.Scene {
	constructor() {
		super();

		/**
         * Static THREE Scene. Add your THREE objects to this.
         * @type {THREE.Scene}
		 */
		this.stage = common.THREEstage;

		/**
         * Static THREE Camera.
         * @type {THREE.PerspectiveCamera}
		 */
		this.camera = common.camera;

		/**
         * @type {TWEEN.Group}
         * @private
	 	 */
		this._tweens = new P3.utils.TWEEN.Group();
	}

	destroy() {
		this._tweens.removeAll();

		super.destroy({children: true});
	}

	resize() {
		this.x = (P3.View.width - common.STAGE_WIDTH) * 0.5;
	}

	update() {
		this._tweens.update();
	}

	get tweens() {
		return this._tweens;
	}
}
